import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { ServiceAdditionalService } from '../../../core/services/service/service-additional/service-additional.service'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'service-additional-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    CurrencyInputDirective,
    MatPrefix,
  ],
  templateUrl: './service-additional-edit.component.html',
  styleUrl: './service-additional-edit.component.scss',
  providers: [ServiceTypeService],
  standalone: true,
})
export class ServiceAdditionalEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceAdditionalService: ServiceAdditionalService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ServiceAdditionalEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceAdditionalService.editServiceAdditional(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    const price =  typeof this.form.get('price')?.value == 'number' ? this.form.get('price')?.value : convertCurrency(this.form.get('price')?.value)
    return {
      id: this.itemEdit.id,
      descricao: this.form.get('description')?.value,
      valor: price,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
      price: [convertCurrency(this.itemEdit.valor), [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
